<template>
  <div v-if="range && data" class="h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('baseObject.code')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.code"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="getInputErrors('code')" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.name')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.name"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="getInputErrors('name')" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isActive')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus v-if="mode == 'view'" :item="data.isActive ? data.isActive : 0" />
          <BaseToggle
            v-else
            :label="$t('baseObject.isActive')"
            name="isActive"
            v-model="data.isActive" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isFromManager')"
          mode="view"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellCheck :item="data.isFromManager ? data.isFromManager : false" />
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';
import BaseTableCellCheck from '../common/BaseTableCellCheck.vue';
import BaseInput from '../common/BaseInput.vue';
import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseToggle from '../common/BaseToggle.vue';
import { type Range } from '@/types/Ranges';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n({ useScope: 'global' });

const props = defineProps<{
  range: Range | undefined;
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
}>();

const data = defineModel<Range>();

onMounted(async () => {});

const isModified = ref<boolean>(false);

watch(
  () => data.value,
  (newData) => {
    validationModel.value.code = newData?.code || '';
    validationModel.value.name = newData?.name || '';
    const valueChanged = JSON.stringify(newData) !== JSON.stringify(props.range);
    isModified.value = valueChanged;
  },
  { deep: true }
);

const validationModel = ref({
  code: data.value?.code || '',
  name: data.value?.name || '',
});

const rules = computed(() => ({
  code: {
    required: helpers.withMessage(`${$t('messages.errors.required')}`, required),
  },
  name: {
    required: helpers.withMessage(`${$t('messages.errors.required')}`, required),
  },
}));

const $v = useVuelidate(rules, validationModel, { $lazy: true });

function getInputErrors(type: 'code' | 'name') {
  if ($v.value[type].required && $v.value[type].required.$invalid)
    return $v.value[type].required.$message;
  else return '';
}
</script>
